import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const ProfileLoadingLayout = () => {
    return (
        <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        </Box>
    );
};
